import { Facture } from "services/apiFactures";
import { formatDate } from "./utils";

export const generateFacture = (facture: Facture) => {
  const formattedDate = formatDate(facture.created_at);
  const vendeurNom = "Le Rucher de Carole et Sylvain";
  const vendeurAdresse = "67 rue du stade, 76590 Torcy le Grand";

  const lignesFacture = facture.panier.map(produit => `
    <tr>
      <td style="border: 1px solid #ddd; padding: 10px;">${produit.libelle}</td>
      <td style="border: 1px solid #ddd; padding: 10px; text-align: center;">${produit.quantite}</td>
      <td style="border: 1px solid #ddd; padding: 10px; text-align: right;">${produit.prix} €</td>
      <td style="border: 1px solid #ddd; padding: 10px; text-align: right; font-weight: bold;">${(parseFloat(produit.prix) * produit.quantite).toFixed(2)} €</td>
    </tr>
  `).join('');

  return `
    <!DOCTYPE html>
    <html lang="fr">
    <head>
      <meta charset="UTF-8">
      <title>Facture ${facture.numero_facture}</title>
      <style>
        body {
          font-family: 'Helvetica Neue', Arial, sans-serif;
          margin: 0;
          padding: 40px;
          color: #333;
        }
        .header {
          border-bottom: 3px solid #E39C04;
          padding-bottom: 20px;
          margin-bottom: 30px;
        }
        h1 {
          color: #E39C04;
          margin: 0;
          font-size: 32px;
        }
        .detail-section h3 {
          color: #666;
          font-size: 14px;
          margin: 0 0 10px 0;
          text-transform: uppercase;
        }
        .detail-section p {
          margin: 5px 0;
          font-size: 14px;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin: 30px 0;
        }
        th {
          background-color: #E39C04;
          padding: 12px;
          text-align: left;
          font-weight: 600;
        }
        td {
          padding: 12px;
        }
        .total-row {
          background-color: #f5f5f5;
          font-weight: bold;
        }
        .total-section {
          margin-top: 30px;
          text-align: right;
        }
        .total-amount {
          font-size: 24px;
          color: #885e02;
          font-weight: bold;
        }
        .footer {
          margin-top: 50px;
          padding-top: 20px;
          border-top: 1px solid #ddd;
          text-align: center;
          color: #666;
          font-size: 12px;
        }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>Le Rucher de Carole et Sylvain</h1>
      </div>
      
      <div class="detail-section">
        <h3>Facture</h3>
        <p><strong>N° ${facture.numero_facture}</strong></p>
        <p>Date: ${formattedDate}</p>
      </div>

      <table>
        <tbody>
          <tr>
            <td style="text-align: left; width: 50%;">
              <p style="margin: 0;"><strong>${facture.client}</strong></p>
              <p style="margin: 0;">${facture.adresse_livraison ?? 'Livraison à définir'}</p>
            </td>
            <td style="text-align: right; width: 50%;">
              <p style="margin: 0;"><strong>${vendeurNom}</strong></p>
              <p style="margin: 0;">${vendeurAdresse}</p>
            </td>
          </tr>
        </tbody>
      </table>

      <table>
        <thead>
          <tr>
            <th style="border: 1px solid #ddd;">Produit</th>
            <th style="border: 1px solid #ddd; text-align: center;">Quantité</th>
            <th style="border: 1px solid #ddd; text-align: right;">Prix unitaire</th>
            <th style="border: 1px solid #ddd; text-align: right;">Total</th>
          </tr>
        </thead>
        <tbody>
          ${lignesFacture}
          <tr class="total-row">
            <td colspan="3" style="border: 1px solid #ddd; text-align: right; font-size: 16px;"><strong class="total-amount">Total</strong></td>
            <td style="border: 1px solid #ddd; text-align: right; font-size: 18px;"><strong class="total-amount">${facture.montant_total} €</strong></td>
          </tr>
        </tbody>
      </table>

      <div class="footer">
        <p>Merci pour votre achat!</p>
        <p>Le Rucher de Carole et Sylvain - Tous droits réservés</p>
      </div>
    </body>
    </html>
  `;
}